<template>
  <v-row style="position: relative" justify="center">
    <v-col cols="12" md="8">
      <v-card
        style="
          border-top: solid;
          border-top-color: #10303d;
          border-top-width: 3px;
        "
      >
        <v-form ref="form">
          <v-toolbar flat>
            <v-toolbar-title
              >{{ $t("feeding-create-edit.title") }}
            </v-toolbar-title>
          </v-toolbar>
          <request-status-indicator
            @try-again="fetchFeedingItem()"
            :requestKey="loadItemRequestKey"
          >
            <v-tabs>
              <v-tab key="information" href="#tab-information"
                >{{ $t("common.informations") }}
              </v-tab>
              <v-tab key="table" href="#tab-table"
                >{{ $t("common.table") }}
              </v-tab>
              <v-tabs-slider></v-tabs-slider>
              <v-tab-item key="information" value="tab-information">
                <v-row class="ma-2">
                  <v-col cols="12">
                    <text-input
                      :label="$t('common.table-name')"
                      :is-required="true"
                      v-model="model.nmArracoamento"
                    ></text-input>
                  </v-col>
                  <v-col cols="12" md="6">
                    <exploration-unit-type-auto-complete
                      :value="model.sgTipoUep"
                      :is-required="true"
                      @value="
                        (newValue) =>
                          updateModelFieldValue('sgTipoUep', newValue)
                      "
                    ></exploration-unit-type-auto-complete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <animal-gender-type-auto-complete
                      :value="model.sgSexo"
                      :is-required="true"
                      @value="
                        (newValue) => updateModelFieldValue('sgSexo', newValue)
                      "
                    ></animal-gender-type-auto-complete>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item key="table" value="tab-table">
                <v-row justify="end">
                  <v-col cols="auto" class="mr-4">
                    <v-btn color="info" dark @click="addNewItem()"
                      >{{ $t("common.new-item") }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-data-table
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      :headers="headers"
                      :no-results-text="$t('common.empty-list-message')"
                      :items="model.arracoamentoPontos"
                      color="secondary"
                      :loading-text="$t('common.loading-list-message')"
                    >
                      <template v-slot:body="props">
                        <draggable
                          v-model="model.arracoamentoPontos"
                          tag="tbody"
                          @update="onTableListUpdate"
                        >
                          <tr
                            v-for="(item, index) in props.items"
                            :key="index"
                            @click="() => editTableItem(item)"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.racao.nmRacao }}</td>
                            <td>{{ item.qtKgSuino }}</td>
                            <td>
                              <record-action-column
                                :on-delete-confirmation="
                                  () => deleteTableItem(item)
                                "
                                :delete-message="
                                  $t('feeding.delete-item-record-text', {
                                    order: item.ordem,
                                  })
                                "
                              />
                            </td>
                          </tr>
                        </draggable>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
            <v-row justify="space-between" class="ma-2">
              <v-col cols="auto">
                <back-button></back-button>
              </v-col>
              <v-col cols="auto">
                <save-button @click="saveRecord()"></save-button>
              </v-col>
            </v-row>
          </request-status-indicator>
        </v-form>
      </v-card>
    </v-col>
    <feeding-table-item-dialog
      v-model="dialog.isVisible"
      :model="dialog.model"
      :invalid-order-list="dialog.invalidOrderList"
      @save="saveTableItem()"
      @dismiss="dismiss()"
    ></feeding-table-item-dialog>
    <v-snackbar v-model="snackbar.isVisible" :color="snackbar.color"
      >{{ snackbar.message }}
    </v-snackbar>
    <request-status-indicator
      :is-absolute="true"
      v-if="feedingItemSaveRequestStatus.loading"
      :request-key="saveItemRequestKey"
    />
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import { RequestStatusKeys } from "@/modules/common";
import {
  ExplorationUnitTypeAutoComplete,
  AnimalGenderTypeAutoComplete,
  RequestStatusIndicator,
  RecordActionColumn,
  SaveButton,
  BackButton,
  TextInput,
} from "@/components";
import draggable from "vuedraggable";

import FeedingTableItemDialog from "./table-item-dialog";
import { forEach } from "lodash";

export default {
  name: "FeedingForm",
  components: {
    draggable,
    ExplorationUnitTypeAutoComplete,
    AnimalGenderTypeAutoComplete,
    RequestStatusIndicator,
    RecordActionColumn,
    SaveButton,
    BackButton,
    FeedingTableItemDialog,
    TextInput,
  },
  data() {
    return {
      loadItemRequestKey: RequestStatusKeys.FEEDING_ITEM.key,
      saveItemRequestKey: RequestStatusKeys.FEEDING_ITEM_SAVE.key,
      model: { arracoamentoPontos: [] },
      headers: [
        { text: this.$t("common.order"), value: "cdOrdem" },
        { text: this.$t("common.feed"), value: "racao.nmRacao" },
        {
          text: this.$t("feeding.kilos-per-animal"),
          value: "qtKgSuino",
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          width: "75px",
        },
      ],
      dialog: {
        isVisible: false,
        model: {},
      },
      snackbar: {
        isVisible: false,
        message: null,
        color: "success",
      },
      hasPendingChanges: false,
    };
  },
  computed: {
    ...mapState({
      feedingItemRequestStatus: (state) =>
        state.requestStatus[RequestStatusKeys.FEEDING_ITEM.key],
      feedingItemSaveRequestStatus: (state) =>
        state.requestStatus[RequestStatusKeys.FEEDING_ITEM_SAVE.key],
    }),
  },
  mounted() {
    if (this.$route.params.id !== null && this.$route.params.id !== undefined) {
      this.fetchFeedingItem();
    }
  },
  methods: {
    onTableListUpdate(evt) {
      forEach(this.model.arracoamentoPontos, (value, idx, item) => {
        this.model.arracoamentoPontos[idx].cdOrdem = idx + 1
      });
    },
    updateModelFieldValue(fieldName, value) {
      this.model[fieldName] = value;
    },
    addNewItem() {
      let order = 1;
      if (this.model.arracoamentoPontos.length) {
        order =
          this.model.arracoamentoPontos[
            this.model.arracoamentoPontos.length - 1
          ].cdOrdem + 1;
      }

      this.dialog.invalidOrderList = this.getInvalidOrderList();
      this.dialog.editIndex = null;
      this.dialog.isVisible = true;
      this.dialog.model = {
        cdOrdem: order,
      };
    },
    editTableItem(item) {
      const itemIndex = this.model.arracoamentoPontos.indexOf(item);
      this.dialog.invalidOrderList = this.getInvalidOrderList(itemIndex);
      this.dialog.editIndex = itemIndex;
      this.dialog.isVisible = true;
      this.dialog.model = {
        ...item,
      };
    },
    getInvalidOrderList(editItemIndex = -1) {
      const invalidOrderList = [];

      this.model.arracoamentoPontos.forEach((point, index) => {
        if (index !== editItemIndex) {
          invalidOrderList.push(point.cdOrdem);
        }
      });

      return invalidOrderList;
    },
    deleteTableItem(item) {
      const itemIndex = this.model.arracoamentoPontos.indexOf(item);
      if (itemIndex > -1) {
        this.model.arracoamentoPontos.splice(itemIndex, 1);
        this.showSnackbar("feeding.point-removed-from-table");
      }
    },
    async fetchFeedingItem() {
      const { id } = this.$route.params;
      await this.$store.dispatch("GetFeedingItemAction", { id });

      if (!this.feedingItemRequestStatus.error) {
        this.updateModelData(this.feedingItemRequestStatus.data);
      }
    },
    async saveRecord() {
      if (!this.$refs.form.validate()) {
        return;
      }

      await this.$store.dispatch("SaveFeedingItemAction", {
        model: this.model,
      });

      if (this.feedingItemSaveRequestStatus.error) {
        this.showSnackbar("common.error-saving-record", "error");
      } else {
        this.showSnackbar("common.successfully-saved-record");
        this.updateModelData(this.feedingItemSaveRequestStatus.data);
      }
    },
    dismiss() {
      this.dialog.isVisible = false;
    },
    saveTableItem() {
      const model = {
        ...this.dialog.model,
      };

      const newList = [...this.model.arracoamentoPontos];
      if (this.dialog.editIndex == null) {
        newList.push(model);
      } else {
        newList[this.dialog.editIndex] = model;
      }

      this.model.arracoamentoPontos = newList;
      this.dismiss();
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = this.$t(message);
      this.snackbar.isVisible = true;
      this.snackbar.color = color;
    },
    updateModelData(data) {
      this.model = {
        ...data,
      };

      setTimeout(() => {
        this.hasPendingChanges = false;
      });
    },
  },
  watch: {
    model: {
      deep: true,
      handler() {
        this.hasPendingChanges = true;
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasPendingChanges) {
      next();
      return;
    }

    const answer = window.confirm(this.$t("feeding.pending-changes-not-saved"));
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
};
</script>
